import ActionTypes from '@ziynx/action-types';

type AnalyticsAction = {
  type: string,
  sectionId: string
}

const initialState = {};

export default function reduceAnalytics(state = initialState, action: AnalyticsAction) {
  if (!action.type) {
    return state;
  }

  switch (action.type) {
  case ActionTypes.analytics.trackPlay.START:
  case ActionTypes.analytics.trackView.START:
    return {
      ...state,
      fetching: true,
      success: false,
      error: null,
    };

  case ActionTypes.analytics.trackView.SUCCESS:
    return {
      ...state,
      ...(action?.response ?? {}),
      fetching: false,
      success: true,
      error: null,
    };

  case ActionTypes.analytics.trackView.ERROR:
    return {
      ...state,
      fetching: false,
      success: false,
      error: action?.error,
    };

  default:
    return state;
  }
}
